// extracted by mini-css-extract-plugin
module.exports = {"activate_button_wrapper":"ActivationPageStyles_activate_button_wrapper__3QHFR"};